import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { MicrosoftUser } from './types/get-microsoft-user';
import getMicrosoftGraphAccessToken from '@/features/Auth/utils/get-microsoft-graph-access-token';

const baseQuery = fetchBaseQuery({
  baseUrl: '',
  prepareHeaders: async (headers): Promise<Headers> => {
    const accessToken = await getMicrosoftGraphAccessToken();

    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`);
    }

    return headers;
  },
});

export const microsoftApi = createApi({
  reducerPath: 'microsoftApi',
  baseQuery,
  endpoints: (build) => ({
    getMicrosoftUser: build.query<MicrosoftUser, undefined>({
      query: () => ({ url: 'https://graph.microsoft.com/v1.0/me' }),
    }),
  }),
});

export const { useGetMicrosoftUserQuery } = microsoftApi;
